import React from 'react';
import PropTypes from 'prop-types';
import { Card, Avatar, Badge } from 'antd';
import { UserOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export const Profile = props => {
  const { user } = props;

  return (
    <Card
      hoverable
      style={{ minWidth: '350px', width: '50vw', padding: '20px' }}
      cover={
        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
          <Badge
            count={user.isVerified ? <CheckCircleOutlined style={{ color: '#52c41a' }} /> : null}
          >
            <Avatar size={100} icon={<UserOutlined />} />
          </Badge>
        </div>
      }
    >
      <Card.Meta
        title={<div style={{ fontSize: '1.5em', fontWeight: 'bold' }}>{user.name}</div>}
        description={
          <>
            {/* <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
              <strong>ID:</strong> {user.id}
            </div> */}
            <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
              <strong>Email:</strong> {user.email}
            </div>
            {/* <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
              <strong>Role:</strong> {user.role}
            </div> */}
            <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
              <strong>Date of registration:</strong>{' '}
              {new Date(+user.createdAt).toLocaleDateString()}
            </div>
          </>
        }
      />
    </Card>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

Profile.propTypes = {
  user: PropTypes.object.isRequired
};

const connectedProfile = connect(mapStateToProps, mapDispatchToProps)(Profile);

export default connectedProfile;
